import { TASK_TYPE, TASK_DISPLAY_NAME } from './tasksConstants';
import { registerElementType } from '../elements/elementRegistry';
import elementConstructor from '../elements/elementConstructor';

const objectConstructorFn = (params) => {
    const { content } = params;
    return {
        ...elementConstructor(params),
        elementType: TASK_TYPE,
        content: {
            textContent: null,
            ...content,
        },
    };
};

export default (params = {}) =>
    registerElementType({
        elementType: TASK_TYPE,
        objectConstructorFn,
        displayName: TASK_DISPLAY_NAME,
        ...params,
    });
